import { AlertCircle, ArrowRight, ShieldCheck } from 'lucide-react'
import logoUrl from '../assets/logo.webp'

/* ===========================================================================
 *  Het scherm voor wie nog niet binnen is
 *
 *  Er staat geen invulveld op. Dat is de hele bedoeling van eenmalig
 *  inloggen: hier is geen wachtwoord, want hier is geen wachtwoordenlijst.
 *  Eén knop, die je naar het dashboard stuurt.
 *
 *  Waarom de fout in gewone taal staat
 *  -----------------------------------
 *
 *  Wat er terugkomt uit de Worker is een woord als "briefje-al-gebruikt".
 *  Dat is precies genoeg voor het logboek en precies niets voor de persoon
 *  die ernaar kijkt. Hier staat wat er aan de hand is en wat hij eraan kan
 *  doen -- want in bijna alle gevallen is het antwoord "druk nog eens op de
 *  knop", en dat is fijn om te weten voordat je iemand belt.
 * =========================================================================== */

const UITLEG: Record<string, string> = {
  'geen-briefje':
    'De link waarmee je hier kwam was niet compleet. Probeer het opnieuw '
    + 'vanaf het dashboard.',
  'briefje-klopt-niet':
    'Het toegangsbewijs klopte niet. Dat gebeurt als een link is aangepast '
    + 'of doorgestuurd. Ga terug naar het dashboard en gebruik de knop daar.',
  'briefje-verlopen':
    'Het toegangsbewijs was verlopen — die is maar een minuut geldig. Klik '
    + 'hieronder om het opnieuw te doen.',
  'briefje-al-gebruikt':
    'Dit toegangsbewijs was al gebruikt. Dat is met opzet: hij werkt één '
    + 'keer. Meld je hieronder gewoon opnieuw aan.',
  'reis-verlopen':
    'Het duurde te lang tussen het beginnen en het inloggen. Probeer het nog '
    + 'een keer.',
  'reis-klopt-niet':
    'Er ging iets mis bij het terugkomen van het dashboard. Begin opnieuw; '
    + 'blijft het gebeuren, meld het dan.',
  'geen-code': 'Het dashboard stuurde geen antwoord mee. Probeer het opnieuw.',
  'dashboard-onbereikbaar':
    'Het dashboard was even niet bereikbaar. Probeer het over een minuut '
    + 'nog eens.',
  'inloggen-mislukt':
    'Het dashboard wilde je niet doorlaten. Kun je daar wel inloggen? Zo ja, '
    + 'meld dit dan — dan zit het aan onze kant.',
  'niet-ingericht':
    'De academie is nog niet helemaal ingesteld. Dit is niets wat jij kunt '
    + 'oplossen; geef het door.',
}

export default function Poort({ fout }: { fout: string | null }) {
  const tekst = fout ? (UITLEG[fout] ?? 'Het inloggen is niet gelukt.') : null

  return (
    <div className="poort">
      <div className="poort-kaart opkomst">
        <span className="plaat">
          <img src={logoUrl} alt="Truckwash1 Group" width={176} height={49} draggable={false} />
        </span>

        <h1>Academy</h1>
        <p className="lead">
          Cursussen over werken met AI, veiligheid en klantcontact. Je logt in
          met hetzelfde account als het dashboard — er is hier geen apart
          wachtwoord.
        </p>

        {tekst && (
          <div className="melding" role="alert">
            <AlertCircle size={17} />
            <span>{tekst}</span>
          </div>
        )}

        {/*
          * Een gewone link en geen knop met JavaScript eromheen. /aanmelden
          * is een adres op de server; laat de browser daar gewoon heen gaan.
          * Dat werkt ook als er iets aan de bundel mankeert.
          */}
        <a className="knop hoofd groot breed" href="/aanmelden">
          Inloggen via het dashboard
          <ArrowRight size={18} />
        </a>

        <p style={{
          marginTop: 22, fontSize: 'var(--fs-meta)', color: 'var(--text-dim)',
          display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center',
        }}>
          <ShieldCheck size={14} />
          Je wachtwoord komt hier niet langs
        </p>
      </div>
    </div>
  )
}
